<div class="table-container">
    <table mat-table [dataSource]="tableData" (keyup)="onKeyup($event)">
        <ng-container matColumnDef="title">
            <th-text *matHeaderCellDef
                     [colspan]="firstColspan"
                     [colIndex]="0"
                     [strong]="true">{{tableHeaders.title}}</th-text>
            <ng-container *matCellDef="let element; let odd = odd;">
                <th-text [colspan]="firstColspan"
                         [colIndex]="0"
                         [emphasis]="true"
                         *ngIf="(element.type | isRowType: [tableRowType.totalHeader, tableRowType.adjustmentHeader])">{{element.title}}</th-text>
                <th-text [colspan]="firstColspan"
                         [colIndex]="0"
                         [collapser]="true"
                         *ngIf="element.type | isRowType: tableRowType.chapterHeader"
                         (onCollapse)="collapse(element.chapterType, $event)">{{element.title}}</th-text>
                <td-container-block-content *ngIf="element.type | isRowType: tableRowType.blockData"
                                            [beginDate]="quotation.begin"
                                            [parity]="odd ? 'odd' : 'even'"
                                            [element]="element"></td-container-block-content>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="total">
            <th-text *matHeaderCellDef
                     [colIndex]="1"
                     [strong]="true"
                     [isSticky]="true">
                <strong>{{tableHeaders.total}}</strong>
            </th-text>
            <ng-container *matCellDef="let element; let odd = odd">
                <th-price *ngIf="(element.type | isRowType: tableRowType.totalHeader) && element.total"
                          [price]="element.total"
                          [isSticky]="true"
                          [parity]="odd ? 'odd' : 'even'"></th-price>
                <th-text *ngIf="(element.type | isRowType: [tableRowType.totalHeader, tableRowType.adjustmentHeader]) && !element.total && isIncludedPage"
                        [colspan]="adjustmentColspan"
                        [isSticky]="true"></th-text>
                <th-text *ngIf="element.type | isRowType: tableRowType.chapterHeader"
                         [colspan]="chapterColspan"></th-text>
                <td-price *ngIf="element.type | isRowType: tableRowType.blockData"
                          [price]="element.block.cost"
                          [quotationCurrency]="quotationCurrency"
                          [parity]="odd ? 'odd' : 'even'"
                          [isSticky]="true"
                          [leftPosition]="349"
                          [currencyXRates]="quotation.details?.xrates"></td-price>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="margin">
            <cell-total-margin *matHeaderCellDef
                               [alternateContent]="tableHeaders.margin"
                               [calculationMode]="calculationMode"
                               [retailCalculationConfig]="retailCalculationConfig"
                               [usedCategories]="usedMarginMarkupCategories"
                               [isEditable]="isEditable && !quotation.isReadOnly"
                               [canEmitRightPosition]="isOptionPage"
                               (onChangeQuotationMargin)="changeQuotationMargin($event)"
                               (onRightPositionChange)="profitLeftPosition = $event"
                               (onMoveModeChange)="onMoveModeChange($event)">
            </cell-total-margin>
            <ng-container *matCellDef="let element; let odd = odd; let rowIndex = index">
                <cell-total-margin *ngIf="(element.type | isRowType: tableRowType.totalHeader) && element.total"
                                   [price]="element.totalRetail"
                                   [calculationMode]="calculationMode"
                                   [usedCategories]="usedMarginMarkupCategories"
                                   [retailCalculationConfig]="retailCalculationConfig"
                                   [isEditable]="isEditable && !quotation.isReadOnly"
                                   [canEmitRightPosition]="isIncludedPage"
                                   [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:0"
                                   (onChangeQuotationMargin)="changeQuotationMargin($event)"
                                   (onRightPositionChange)="profitLeftPosition = $event"
                                   (onMoveModeChange)="onMoveModeChange($event)"
                                   (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:0 })"></cell-total-margin>
                <cell-block-margin *ngIf="element.type | isRowType: tableRowType.blockData"
                                   [price]="element.block.retail"
                                   [calculationMode]="calculationMode"
                                   [parity]="odd ? 'odd' : 'even'"
                                   [isSticky]="true"
                                   [isEditable]="isEditable && !quotation.isReadOnly"
                                   [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:0"
                                   (onMoveModeChange)="onMoveModeChange($event)"
                                   (onChangeMargin)="changeBlockMargin($event, element.block.totalPrices[0].id, element.block.id)"
                                   (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:0 })"></cell-block-margin>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="gain">
            <th-text *matHeaderCellDef [colIndex]="3" [strong]="true" [isSticky]="true">
                <strong>{{tableHeaders.gain}}</strong>
            </th-text>
            <ng-container *matCellDef="let element; let odd = odd; let rowIndex = index">
                <cell-price *ngIf="(element.type | isRowType: tableRowType.totalHeader) && element.total && isIncludedPage"
                            [price]="element.totalRetail.profit"
                            [parity]="odd ? 'odd' : 'even'"
                            [canHaveFooter]="false"
                            [isEditable]="isEditable && !quotation.isReadOnly"
                            [leftPosition]="profitLeftPosition"
                            [isSticky]="true"
                            [canEmitRightPosition]="isIncludedPage"
                            [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:1"
                            [rightEmissionAddition]="188"
                            (onPriceChange)="changeQuotationProfit($event)"
                            (onMoveModeChange)="onMoveModeChange($event)"
                            (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:1 })"
                            (onRightPositionChange)="setPositionsFromGain($event)"></cell-price>
                <cell-price *ngIf="element.type | isRowType: tableRowType.blockData"
                            [price]="element?.block?.retail?.profit"
                            [parity]="odd ? 'odd' : 'even'"
                            [canHaveFooter]="false"
                            [isEditable]="isEditable && !quotation.isReadOnly"
                            [leftPosition]="profitLeftPosition"
                            [isSticky]="true"
                            [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:1"
                            [canEmitRightPosition]="isOptionPage"
                            (onMoveModeChange)="onMoveModeChange($event)"
                            (onPriceChange)="changeBlockProfit($event, element.block.totalPrices[0].id, element.block.id)"
                            (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:1 })"
                            (onRightPositionChange)="setPositionsFromGain($event)"></cell-price>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="commissionIsViewable" matColumnDef="commission">
            <cell-total-margin *matHeaderCellDef
                               [alternateContent]="tableHeaders.commission"
                               [calculationMode]="commissionCalculationMode"
                               [retailCalculationConfig]="commissionCalculationConfig"
                               [usedCategories]="usedCommissionCategories"
                               [isEditable]="commissionIsEditable && !quotation.isReadOnly"
                               [canEmitRightPosition]="isOptionPage"
                               (onChangeQuotationMargin)="changeQuotationCommission($event)"
                               (onMoveModeChange)="onMoveModeChange($event)">
            </cell-total-margin>
            <ng-container *matCellDef="let element; let odd = odd; let rowIndex = index">
                <cell-total-margin *ngIf="(element.type | isRowType: tableRowType.totalHeader) && element.total"
                                   [price]="element.totalRetail"
                                   [calculationMode]="commissionCalculationMode"
                                   [usedCategories]="usedCommissionCategories"
                                   [retailCalculationConfig]="commissionCalculationConfig"
                                   [isEditable]="commissionIsEditable && !quotation.isReadOnly"
                                   [canEmitRightPosition]="isIncludedPage"
                                   [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:2"
                                   (onChangeQuotationMargin)="changeQuotationCommission($event)"
                                   (onMoveModeChange)="onMoveModeChange($event)"
                                   (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:2 })"
                                   (onRightPositionChange)="commissionTotalLeftPosition = $event"></cell-total-margin>
                <cell-block-margin *ngIf="element.type | isRowType: tableRowType.blockData"
                                   [price]="element.block.retail"
                                   [calculationMode]="commissionCalculationMode"
                                   [parity]="odd ? 'odd' : 'even'"
                                   [isSticky]="true"
                                   [isEditable]="false"
                                   [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:2"
                                   (onMoveModeChange)="onMoveModeChange($event)"
                                   (onChangeMargin)="changeBlockCommission($event, element.block.totalPrices[0].id, element.block.id)"
                                   (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:2 })"></cell-block-margin>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="commissionTotal">
            <th-text *matHeaderCellDef [colIndex]="6" [strong]="true" [isSticky]="true">
                <strong>{{tableHeaders.commissionTotal}}</strong>
            </th-text>
            <ng-container *matCellDef="let element; let odd = odd; let rowIndex = index">
                <cell-price *ngIf="(element.type | isRowType: tableRowType.totalHeader) && element.total && isIncludedPage"
                            [price]="element.totalRetail.commissionTotal"
                            [parity]="odd ? 'odd' : 'even'"
                            [canHaveFooter]="false"
                            [isEditable]="false"
                            [leftPosition]="commissionTotalLeftPosition"
                            [isSticky]="true"
                            [canEmitRightPosition]="isIncludedPage"
                            [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:3"
                            (onPriceChange)="changeQuotationProfit($event)"
                            (onMoveModeChange)="onMoveModeChange($event)"
                            (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:3 })"
                            (onRightPositionChange)="setPositionsFromCommissionTotal($event)"></cell-price>
                <cell-price *ngIf="element.type | isRowType: tableRowType.blockData"
                            [price]="element?.block?.retail?.commissionTotal"
                            [parity]="odd ? 'odd' : 'even'"
                            [canHaveFooter]="false"
                            [isEditable]="false"
                            [leftPosition]="commissionTotalLeftPosition"
                            [isSticky]="true"
                            [canEmitRightPosition]="isOptionPage"
                            [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:3"
                            (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:3 })"
                            (onRightPositionChange)="setPositionsFromCommissionTotal($event)"></cell-price>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="vat">
            <th-text *matHeaderCellDef [colIndex]="7" [strong]="true" [isSticky]="true" >
                <strong>{{tableHeaders.vat}}</strong>
            </th-text>
            <ng-container *matCellDef="let element; let odd = odd; let rowIndex = index">
                <td-price *ngIf="(element.type | isRowType: tableRowType.totalHeader) && element.total"
                          [price]="element.totalVat"
                          [quotationCurrency]="quotationCurrency"
                          [parity]="odd ? 'odd' : 'even'"
                          [isSticky]="true"
                          [leftPosition]="vatLeftPosition"
                          [currencyXRates]="quotation.details?.xrates"
                          [canEmitRightPosition]="true"
                          (onRightPositionChange)="setTotalRetailLeftPosition($event)"></td-price>

                <td-price *ngIf="element.block?.vat"
                          [price]="element.block.vat"
                          [quotationCurrency]="quotationCurrency"
                          [parity]="odd ? 'odd' : 'even'"
                          [isSticky]="true"
                          [leftPosition]="vatLeftPosition"
                          [currencyXRates]="quotation.details?.xrates"
                          [canEmitRightPosition]="true"
                          (onRightPositionChange)="setTotalRetailLeftPosition($event)"></td-price>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="retailTotal">

            <th-total-with-vat-configuration *matHeaderCellDef
                                             [colIndex]="8"
                                             [title]="tableHeaders.retailTotal"
                                             [vatConfiguration]="quotationVatConfiguration"
                                             [leftPosition]="totalRetailLeftPosition"
                                             [isReadOnly]="quotation.isReadOnly"
                                             (onChangeQuotationVatConfiguration)="changeQuotationVatConfiguration($event)">
            </th-total-with-vat-configuration>

            <ng-container *matCellDef="let element; let odd = odd; let rowIndex = index">
                <cell-price *ngIf="(element.type | isRowType: tableRowType.totalHeader) && isIncludedPage"
                            [price]="quotationVatConfiguration | retailAccordingToVat: element.totalRetail: element.totalRetailIncludingVat"
                            [parity]="odd ? 'odd' : 'even'"
                            [canHaveFooter]="false"
                            [strong]="true"
                            [isSticky]="true"
                            [leftPosition]="totalRetailLeftPosition"
                            [isEditable]="isEditable && !quotation.isReadOnly"
                            [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:4"
                            (onMoveModeChange)="onMoveModeChange($event)"
                            (onPriceChange)="changeQuotationTotalRetail($event)"
                            (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:4 })"></cell-price>

                <cell-adjustment *ngIf="(element.type | isRowType: tableRowType.adjustmentHeader) && isIncludedPage"
                                 [price]="quotationVatConfiguration | retailAccordingToVat: element.totalRetail: element.totalRetailIncludingVat"
                                 [strong]="true"
                                 [isSticky]="true"
                                 [leftPosition]="totalRetailLeftPosition"
                                 [parity]="odd ? 'odd' : 'even'"
                                 [isEditable]="isEditable && !quotation.isReadOnly"
                                 [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:4"
                                 (onMoveModeChange)="onMoveModeChange($event)"
                                 (onChangeAdjustment)="changeQuotationAdjustment($event)"
                                 (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:4 })">
                </cell-adjustment>

                <cell-price *ngIf="element.type | isRowType: tableRowType.blockData"
                            [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:4"
                            [price]="quotationVatConfiguration | retailAccordingToVat: element.block.retail: element.block.retailIncludingVat"
                            [parity]="odd ? 'odd' : 'even'"
                            [canHaveFooter]="false"
                            [isEditable]="isEditable && !quotation.isReadOnly"
                            [strong]="true"
                            [isSticky]="true"
                            [leftPosition]="totalRetailLeftPosition"
                            (onMoveModeChange)="onMoveModeChange($event)"
                            (onPriceChange)="changeBlockRetail($event, element.block.totalPrices[0].id, element.block.id)"
                            (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:4 })"></cell-price>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="travellers">
            <ng-container *matHeaderCellDef>
                <th-traveller [traveller]="traveller"
                              [index]="travellerIndex"
                              [vatConfiguration]="quotationVatConfiguration"
                              *ngFor="let traveller of tableHeaders.travellers; let travellerIndex = index; trackBy: travellerTrackBy"></th-traveller>
            </ng-container>
            <ng-container *matCellDef="let element; let odd = odd; let rowIndex = index">
                <ng-container *ngIf="(element.type | isRowType: tableRowType.totalHeader)">
                    <cell-price
                            *ngFor="let traveller of element.travellers; let travellerIndex = index; trackBy: travellerTrackBy"
                            [price]="quotationVatConfiguration| retailAccordingToVat: traveller.retail: traveller.retailIncludingVat"
                            parity="even"
                            [isEditable]="isEditable && !quotation.isReadOnly"
                            [canHaveFooter]="false"
                            [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:(5+travellerIndex)"
                            (onMoveModeChange)="onMoveModeChange($event)"
                            (onPriceChange)="changeTravellerTotalRetail($event, traveller.id)"
                            (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:(5+travellerIndex) })"></cell-price>
                </ng-container>
                <ng-container *ngIf="(element.type | isRowType: tableRowType.adjustmentHeader)">
                    <cell-adjustment
                            *ngFor="let traveller of element.travellers; let travellerIndex = index; trackBy: travellerTrackBy"
                            [isEditable]="isEditable && !quotation.isReadOnly"
                            [price]="quotationVatConfiguration| retailAccordingToVat: traveller.retail: traveller.retailIncludingVat"
                            [isKeyboardOpen]="focusCoordsFromKeyboard | isSameCoord:rowIndexSubtract[rowIndex]:(5+travellerIndex)"
                            (onMoveModeChange)="onMoveModeChange($event)"
                            (onFocusField)="emitFocusChange({rowIndex: rowIndexSubtract[rowIndex], colIndex:(5+travellerIndex) })"
                            (onChangeAdjustment)="changeTravellerAdjustment($event, traveller.id)"></cell-adjustment>
                </ng-container>
                <ng-container *ngIf="element.type | isRowType: tableRowType.blockData">
                    <td-price *ngFor="let traveller of element.block.travellerPrices;trackBy: travellerPriceTrackBy "
                              [price]="quotationVatConfiguration| retailAccordingToVat: traveller.retail: traveller.retailIncludingVat"
                              [parity]="odd ? 'odd':'even'"></td-price>
                </ng-container>
            </ng-container>
        </ng-container>

        <ng-container matColumnDef="end">
            <th-end *matHeaderCellDef></th-end>
            <th-end *matCellDef></th-end>
        </ng-container>

        <tr id="table-head" class="header-table-sticky" mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row
            *matRowDef="let row; columns: displayedColumns; let i = index;"
            [ngClass]="{
                'header-table-sticky': i === 0 || i === 1
            }"
            [attr.id]="'row' + i"
            [hidden]="(row.type | isRowType: tableRowType.blockData) && !areVisibleBlocks[row.chapterType]"></tr>
    </table>
</div>
